/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').List} List
 * @typedef {import('../util/indent-lines.js').Map} Map
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').Handle} Handle
 */
import { checkBullet } from '../util/check-bullet.js';
import { checkListItemIndent } from '../util/check-list-item-indent.js';
import { containerFlow } from '../util/container-flow.js';
import { indentLines } from '../util/indent-lines.js';
/**
 * @type {Handle}
 * @param {ListItem} node
 */

export function listItem(node, parent, context) {
  var listItemIndent = checkListItemIndent(context);
  var bullet = context.bulletCurrent || checkBullet(context); // Add the marker value for ordered lists.

  if (parent && parent.type === 'list' && parent.ordered) {
    bullet = (typeof parent.start === 'number' && parent.start > -1 ? parent.start : 1) + (context.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
  }

  var size = bullet.length + 1;

  if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.type === 'list' && parent.spread || node.spread)) {
    size = Math.ceil(size / 4) * 4;
  }

  var exit = context.enter('listItem');
  var value = indentLines(containerFlow(node, context), map);
  exit();
  return value;
  /** @type {Map} */

  function map(line, index, blank) {
    if (index) {
      return (blank ? '' : ' '.repeat(size)) + line;
    }

    return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line;
  }
}